// extracted by mini-css-extract-plugin
module.exports = {"iaWidgetStyle":"AiStyle_iaWidgetStyle__22gu0","c-ivtLaR-ftPdvq-withChat-false":"AiStyle_c-ivtLaR-ftPdvq-withChat-false__38zhg","c-PJLV":"AiStyle_c-PJLV__SFOF-"};